import { render, staticRenderFns } from "./data-select.vue?vue&type=template&id=30c077ba&scoped=true"
import script from "./data-select.vue?vue&type=script&lang=js"
export * from "./data-select.vue?vue&type=script&lang=js"
import style0 from "./data-select.vue?vue&type=style&index=0&id=30c077ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c077ba",
  null
  
)

export default component.exports